import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import * as Number from 'fp-ts/number';
import * as Ord from 'fp-ts/Ord';
import { useContext } from 'react';
import { BlockWidthContext } from './block-width-context';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
export var breakpoints = {
  xs: 250,
  sm: 450,
  md: 600,
  lg: 800,
  xl: 1000
};
export var useCheckWidth = function useCheckWidth(_ref) {
  var width = _ref.width,
      _ref$minWidth = _ref.minWidth,
      minWidth = _ref$minWidth === void 0 ? 0 : _ref$minWidth,
      _ref$maxWidth = _ref.maxWidth,
      maxWidth = _ref$maxWidth === void 0 ? Infinity : _ref$maxWidth;
  var containerWidth = useContext(BlockWidthContext);
  var minimum = typeof minWidth === 'number' ? minWidth : breakpoints[minWidth];
  var maximum = typeof maxWidth === 'number' ? maxWidth : breakpoints[maxWidth];
  return Ord.between(Number.Ord)(minimum, maximum)(width !== null && width !== void 0 ? width : containerWidth);
};
export var useContainerMediaQuery = function useContainerMediaQuery(_ref2) {
  var minWidth = _ref2.minWidth,
      maxWidth = _ref2.maxWidth;
  return useCheckWidth({
    minWidth: minWidth,
    maxWidth: maxWidth
  });
};
export var ContainerMediaQuery = function ContainerMediaQuery(_ref3) {
  var children = _ref3.children,
      props = _objectWithoutProperties(_ref3, _excluded);

  var isCorrectSize = useContainerMediaQuery(_objectSpread({}, props));
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isCorrectSize && children
  });
};